import { Icons, EntityAction, EntityActions } from '@cast/design-system';

import { useEdgeConfigurationAbilities } from '../_hooks/useEdgeConfigurationAbilities';
import { EdgeConfigurationListItem } from '../types';

type Props = {
  config: EdgeConfigurationListItem;
  isSettingDefault: boolean;
  onEditClick: () => void;
  onDeleteClick: () => void;
  onSetAsDefaultClick: () => void;
};

export const EdgeConfigurationActions = ({
  config,
  isSettingDefault,
  onEditClick,
  onDeleteClick,
  onSetAsDefaultClick,
}: Props) => {
  const { canUpdate, canDelete } = useEdgeConfigurationAbilities();

  const isDefault = config.default;

  return (
    <EntityActions>
      {!isDefault && canUpdate && (
        <EntityAction
          testId={`set-as-default-action-${config.id}`}
          startAdornment={<Icons.Star />}
          disabled={isSettingDefault}
          onClick={onSetAsDefaultClick}
        >
          Set as default
        </EntityAction>
      )}
      <EntityAction
        testId={`edit-edge-configuration-action-${config.id}`}
        startAdornment={<Icons.PencilSimple />}
        disabled={!canUpdate || !config}
        onClick={onEditClick}
      >
        Edit
      </EntityAction>
      <EntityAction
        testId={`delete-edge-configuration-action-${config.id}`}
        startAdornment={<Icons.Trash />}
        disruptive
        disabled={!canDelete || !config || isDefault}
        onClick={onDeleteClick}
      >
        Delete
      </EntityAction>
    </EntityActions>
  );
};
